import {Component, Input} from '@angular/core';
import {CustomDialogComponent} from "../../custom-dialog/custom-dialog.component";
import {EtablissementData} from "../../utils/data/etablissments-data";
import {MatDialog} from "@angular/material/dialog";
import {PersonsService} from "../../../services/persons.service";
import {FlagService} from "../../services/flag.service";
import {FlagType} from "../../utils/enums";
import { AddUserComponent } from '../../../core/agency/agency-users/add-user/add-user.component';
import { DetailsUserComponent } from '../../../core/agency/agency-users/details-user/details-user.component';
import { EstablishmentService } from '../../../services/establishment.service';


@Component({
  selector: 'app-user-action',
  templateUrl: './user-action.component.html',
  styleUrl: './user-action.component.scss'
})
export class UserActionComponent {
  @Input() data: any = undefined;
  @Input() column: any = undefined;


constructor(private dialog: MatDialog, private personService: PersonsService,private agencyService : EstablishmentService, private flag: FlagService) {

}

editDialog(): void {
  this.agencyService.getUserById(this.data.id).subscribe({
    next: (res: any) => {
      if (res && res.image) {
        this.data.image = res.image;
      }
      if (res && res.phoneNumber) {
        this.data.numTel = res.phoneNumber;
      }
      console.log('Edit dialog data:', this.data);
      const dialogRef = this.dialog.open(AddUserComponent, {
        data: this.data
      });
      dialogRef.afterClosed().subscribe(value => {
        if (value) {
          this.personService.toggleRefreshData();
        }
      });
    },
    error: () => {
      console.error('Failed to get user image');
      this.data.image = 'default_image.png'; // Or a default fallback
      const dialogRef = this.dialog.open(AddUserComponent, {
        data: this.data
      });
      dialogRef.afterClosed().subscribe(value => {
        if (value) {
          this.personService.toggleRefreshData();
        }
      });
    }
  });
}


 // view person
  viewDialog = (row: any) => {
    console.log(this.data);
    this.dialog.open(DetailsUserComponent, {
      width: '666px',
      height: '100vh',
      position: { right: '0' },
      backdropClass: 'bg-transparent',
      data: this.data,
    });
  };

  deletePerson() {
    const dialogRef  = this.dialog.open(CustomDialogComponent, {
      data: {
        title: EtablissementData.monEtablissement.deletePersonDialog.title,
        description: EtablissementData.monEtablissement.deletePersonDialog.description,
        primaryLabel: EtablissementData.monEtablissement.deletePersonDialog.primaryButton,
        secondaryLabel: EtablissementData.monEtablissement.deletePersonDialog.secondButton,
      },
      maxWidth: '464px',
      autoFocus: false
    })
    dialogRef.afterClosed().subscribe(value => {
      if (value)
         {
          this.agencyService.deleteAgencyUser(this.data.id).subscribe({
          next: res =>
             {
                this.flag.displayFlag('La suppression est effectuée avec succès !', FlagType.success);
                this.agencyService.triggerRefresh();
                this.personService.toggleRefreshData();                
              },
          error: err => {
          console.error('Delete error:', err);
          }
        });
      }
    })
  }

  getImageFromGivenUserId(userId: number) : any {
    this.agencyService.getUserById(userId).subscribe({
      next: (res: any) => {
        if (res && res.image) {
          console.log('Image found:', res.image);
          return res.image; // Return the image if found
        }
      },
      error: () => {
        return 'error'; // Default image on error
      }
    });
}

}
